module.exports = __webpack_public_path__ + "static/26-77ec70efccf4ce7a79ce7563825fbbb3.gif";